import { render, staticRenderFns } from "./SessionPersonOverlaps.vue?vue&type=template&id=ec2e889e&"
import script from "./SessionPersonOverlaps.vue?vue&type=script&lang=js&"
export * from "./SessionPersonOverlaps.vue?vue&type=script&lang=js&"
import style0 from "./SessionPersonOverlaps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports